// extracted by mini-css-extract-plugin
var _1 = "RequestEditApplicantAddressModalFields-moduleformFieldsContainer__QAPG2";
var _2 = "RequestEditApplicantAddressModalFields-modulesection__GCyqU";
var _3 = "RequestEditApplicantAddressModalFields-moduleseparator__SlkYu";
export { _1 as "formFieldsContainer", _2 as "section", _3 as "separator" }
